import { useTranslation } from 'react-i18next';

import BotonWhatsapp from "./BotonWhatsapp";
import Newsletter from "../Inicio/Newsletter.jsx";
import { RUTA_IMATGES, rutaPagina } from './contenidoCamprodon.js';

// Com arribar a l'hotel (Google Maps) i número de registre turístic.
const URL_COM_ARRIBAR = "https://www.google.com/maps/dir/?api=1&destination=Hotel+Camprodon,+Pla%C3%A7a+del+Dr.+Robert,+3,+17867+Camprodon,+Girona";
const REGISTRE = "HG-000040";


const Footer = ({ datos, terminos, protocolos, avisolegal, politicaprivacidad, lang, ruta, logos_pie, senseNewsletter = false }) => {

    const { t } = useTranslation();

    var currentTime = new Date();
    var year = currentTime.getFullYear();

    var preidioma = ""
    if (lang != 'es') preidioma = lang + "/";

    const teTexto = (texto) => texto && texto.ladesc !== null && texto.ladesc !== "";

    // Mateixos enllaços que el peu del disseny, a les pàgines de BedLoop.
    const menu = [
        { label: t("Newsletter"), href: rutaPagina("newsletter", lang) },
        { label: t("Contacto"), href: "/" + preidioma + t("contacto") },
    ];
    // "Condicions de reserva" mostra les polítiques de cancel·lació de BedLoop.
    menu.push({ label: t("Condiciones de reserva"), href: "/" + preidioma + t("politica-de-cancelacion") });
    if (teTexto(avisolegal)) menu.push({ label: t("Aviso Legal"), href: "/" + preidioma + t("legal") });
    if (teTexto(politicaprivacidad)) menu.push({ label: t("Política de privacidad"), href: "/" + preidioma + t("politica-de-privacidad") });
    menu.push({ label: t("Política de cookies"), href: "/" + preidioma + t("cookies") });
    if (teTexto(protocolos)) {
        menu.push({ label: t("Protocolos"), href: "/" + preidioma + t("protocolos") });
    }

    const logos = logos_pie
        ? [1, 2, 3, 4].filter((n) => logos_pie["url_" + n] != "" && logos_pie["imagen_" + n] != "")
        : [];

    const telefono = datos.telefono_fiscal || "";

    return (
        <div className="hc">
            {/* Franja del newsletter, a totes les pàgines com al disseny. */}
            {!senseNewsletter && <Newsletter lang={lang} config={datos} />}
            <footer className="c-footer potblur">
                <div className="o-container c-footer__inner-container">
                    <nav>
                        <ul className="c-footer__menu list-style-none">
                            {menu.map((item, index) => (
                                <li className="c-footer__menu-item" key={index}>
                                    <a href={item.href} className="c-menu__link">{item.label}</a>
                                </li>
                            ))}
                        </ul>
                    </nav>
                    <div className="c-footer__location-contact">
                        <svg aria-hidden="true" focusable="false" className="c-icon" width="200" height="82">
                            <use href={RUTA_IMATGES + "icons-sprite.svg#sprite-icon-logo-footer"}></use>
                        </svg>
                        <div className="c-footer__location-contact-texts">
                            <p className="c-footer__location-name text-uppercase">{datos.nombre_comercial}</p>
                            <span>{datos.direccion_fiscal}</span>
                            <span>
                                {telefono && <a href={"tel:" + telefono.replace(/\s/g, "")}>{telefono}</a>}
                                {telefono && datos.email_fiscal && <br />}
                                {datos.email_fiscal && <a href={"mailto:" + datos.email_fiscal} className="color-white">{datos.email_fiscal}</a>}
                            </span>
                            <span>{REGISTRE}</span>
                            <a href={URL_COM_ARRIBAR} target="_blank" rel="noopener noreferrer" className="c-button c-button--outline color-white d-flex-center">{t("¿Cómo llegar?")}</a>
                        </div>
                    </div>
                    <div className="c-footer__logos">
                        {logos.map((n) => (
                            <a href={logos_pie["url_" + n]} target="_blank" key={n}>
                                <img src={ruta + "/piedepagina/1/logos/" + n + "/" + logos_pie["imagen_" + n]} alt="" />
                            </a>
                        ))}
                    </div>
                    <div className="c-footer__credits">
                        <span>&copy; {year} {datos.nombre_comercial}</span>
                    </div>
                </div>
            </footer>

            <BotonWhatsapp
                websgrupo={datos}
            />
        </div>
    );
};
export default Footer;
